
const config = {
  baseUrl: process.env.REACT_APP_BASE_URL166 || "https://166.bodecom.com",
  excelProyectosPorOrganizaciones:
    process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES166 ||
    "https://166.bodecom.com",
  baseDirUrl:
    process.env.REACT_APP_BASE_DIR_URL166 ||
    "/var/www/166/backend/DocumentosFAO/DocumentosReportes",
};
export default config;

/*
const config = {
  baseUrl: "http://localhost:5001",
  excelProyectosPorOrganizaciones:
    process.env.REACT_APP_EXCEL_PROYECTOS_POR_ORGANIZACIONES166 ||
    "defaultExcelUrl",
  baseDirUrl:
    process.env.REACT_APP_BASE_DIR_URL166 ||
    "/Volumes/bodecom/bodecom_166/backend/DocumentosFAO/DocumentosReportes",
};

export default config;
*/
